export default __webpack_public_path__ + "static/logo-yungjin-7c2fcae1ffe28eb641039e786328d0af.jpg";